<template>
  <div>
    这里以后放服务器状态信息
  </div>
</template>

<script>
export default {
  name: "ControlHome"
}
</script>

